// #region --------------- Matter Trust Check React Query hooks ----------------------

import {
  createMatterTrustCheckConnectionV1,
  createMatterTrustCheckV1,
  deleteMatterTrustCheckV1,
  updateMatterTrustCheckV1,
} from "@/lib/data/requests/matters/matter-trust-check";
import { queryKeys } from "@/lib/data/static/query-keys";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";

export const useCreateMatterTrustCheck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof createMatterTrustCheckV1>[0]) =>
      createMatterTrustCheckV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error creating matter trust check");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Matter trust check created successfully");
    },
  });
};

export const useUpdateMatterTrustCheck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof updateMatterTrustCheckV1>[0]) =>
      updateMatterTrustCheckV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error updating matter trust check");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Matter trust check updated successfully");
    },
  });
};

export const useDeleteMatterTrustCheck = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof deleteMatterTrustCheckV1>[0]) =>
      deleteMatterTrustCheckV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting matter trust check");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Matter trust check deleted successfully");
    },
  });
};

export const useCreateMatterTrustCheckConnection = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<typeof createMatterTrustCheckConnectionV1>[0],
    ) => createMatterTrustCheckConnectionV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Error creating matter trust check connection",
      );
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matters],
      });
    },
    onSuccess: () => {
      toast.success("Matter trust check connection created successfully");
    },
  });
};
